export default __webpack_public_path__ + "static/media/premium3.f9c1cadb.png";